<template>
  <div>
    <h2>月注册用户</h2>
    <div id="container" />
  </div>
</template>

<script>
  import { Chart } from '@antv/g2';
  import Global from '../components/Global';

  export default {
    name: "StorkUserCount",
    data() {
      return {
        count: []
      };
    },
    mounted() {
      this.getStorkUserCount();
    },
    methods: {
      // 初始化线形图
      initChart() {
        const chart = new Chart({
          container: 'container',
          autoFit: true,
          height: 650,
          padding: [20, 50]
        });

        chart.data(this.count);
        chart.scale({
          year: {
            range: [0, 1],
          },
          value: {
            min: 0,
            nice: true,
          },
        });

        chart.tooltip({
          showCrosshairs: true, // 展示 Tooltip 辅助线
          shared: true,
        });

        chart.line().position('create_time*count').label('count');
        chart.point().position('create_time*count');

        chart.render();
      },
      // 请求数据
      getStorkUserCount() {
        let that = this;
        that.axios({
          method: 'GET',
          url: Global.accountUrl + '/storkCollectData/getStorkUserCount'
        }).then(
          function (response) {
            if (response.data.code == 200) {
              that.count = response.data.data;
              that.initChart();
            } else {
              that.$message.error('请求数据失败');
            }
          }
        );
      }
    },
  }

</script>



// WEBPACK FOOTER //
// src/components/StorkUserCount.vue